export default __webpack_public_path__ + "static/media/itFlag.c276d661.svg";